module.exports = "../images/rates-contact.jpg?v=f36db7a";